import React, { useState } from "react";
import { useTasks } from "./store/useTasks";
import KanbanView from "./views/KanbanView";
import ListView from "./views/ListView";
import TimelineView from "./views/TimelineView";
import FilterBar, { Filters } from "./components/FilterBar";

type View = "kanban" | "list" | "timeline";

const App: React.FC = () => {
  const { tasks } = useTasks();
  const [view, setView] = useState<View>("kanban");

  // Filters state
  const [filters, setFilters] = useState<Filters>({
    status: [],
    priority: [],
    assignee: [],
    fromDate: "",
    toDate: "",
  });

  // Apply filters to tasks
  const filteredTasks = tasks.filter((t) => {
    if (filters.status.length && !filters.status.includes(t.status)) return false;
    if (filters.priority.length && !filters.priority.includes(t.priority)) return false;
    if (filters.assignee.length && !filters.assignee.includes(t.assignee)) return false;
    if (filters.fromDate && new Date(t.dueDate) < new Date(filters.fromDate)) return false;
    if (filters.toDate && new Date(t.dueDate) > new Date(filters.toDate)) return false;
    return true;
  });

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900">
      {/* Header */}
      <header className="flex items-center justify-between p-4 bg-white shadow">
        <h1 className="text-xl font-bold">Project Tracker</h1>
        <nav className="flex gap-2">
          <button
            onClick={() => setView("kanban")}
            className={`px-3 py-1 rounded ${
              view === "kanban" ? "bg-blue-600 text-white" : "bg-gray-200"
            }`}
          >
            Kanban
          </button>
          <button
            onClick={() => setView("list")}
            className={`px-3 py-1 rounded ${
              view === "list" ? "bg-blue-600 text-white" : "bg-gray-200"
            }`}
          >
            List
          </button>
          <button
            onClick={() => setView("timeline")}
            className={`px-3 py-1 rounded ${
              view === "timeline" ? "bg-blue-600 text-white" : "bg-gray-200"
            }`}
          >
            Timeline
          </button>
        </nav>
      </header>

      {/* Filter bar */}
      <section className="p-4 bg-gray-50 border-b">
        <FilterBar onFilterChange={setFilters} />
      </section>

      {/* Main content */}
      <main className="p-4">
        {view === "kanban" && <KanbanView tasks={filteredTasks} />}
        {view === "list" && <ListView tasks={filteredTasks} />}
        {view === "timeline" && <TimelineView tasks={filteredTasks} />}
      </main>
    </div>
  );
};

export default App;





